<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader ,ModelSelect},
  data() {
    return {
      title: "Sales Manager Agent List",
      items: [
        {
          text: "Sales Manager",
          href: "/",
        },
        {
          text: "Sales Manager Agent List",
          active: true,
        },
      ],
      salesmanagers: [],
        arr_agents:{},
        arr_admins:{},
      agents: [],
      admins: [],
        manager_customer:[],
        display_div:true,
        errors:null,
        visible:false,
        message:"",
        manager_user_id:"",
        customer_user_id:"",
    };
  },
  mounted() {
    // this.getmanagerListList();
    this.getAgentList();
    this.getAdminList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      toggleDiv: function() {
          this.display_div = !this.display_div;
      },
    async getAgentList() {
      try {
        axios
          .get("/api/user/approved/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                        if(temp[i].approved_agents[0].approval_status=='approved') {
                            temp[i].value = temp[i].id;
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            arr.push(temp[i]);
                        }
                    }

                }
                this.agents = arr;
                var that = this;
                response.data.data.map(function (value, key) {
                    that.$set(
                        that.arr_agents,
                        value.id,
                        value.first_name + " " + value.last_name + "  (" + value.username +")"
                    );
                });
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getAdminList() {
      try {
        axios
          .get("/api/admin/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              var that = this;
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++){
                    temp[i].value = temp[i].id;
                    temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                    arr.push(temp[i]);
                }
                this.admins = arr;
                response.data.data.map(function (value, key) {
                    that.$set(
                        that.arr_admins,
                        value.id,
                        value.first_name + " " + value.last_name  + "  (" + value.username +")"
                    );
                });
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getmanagerListList() {
      try {
        axios
          .get("/api/sales_manager/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.manager_customer = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async clear() {
          this.customer_user_id="";
          this.manager_user_id="";
      },
    async deleteWarning(salesmanager) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(salesmanager);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    deleteItem: function deleteItem(salesmanager) {
      var _this = this;
      axios
        .post("/api/sales_manager/delete/" + salesmanager.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          if(response.data.status){
              _this.$swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: 'Successfully Remove Sales Manager From Customer',
                  showConfirmButton: false,
                  timer: 1000
              });
              _this.search();
              _this.hasDeleted = false;
          } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
          }
        });
    },
      async search() {
          try {
              axios
                  .get("/api/sales_manager/search", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                          manager_user_id: this.manager_user_id,
                          customer_user_id: this.customer_user_id,
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                        this.manager_customer=response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
      <div class="row">
          <div class="col-lg-12">
              <div class="card">
                  <div class="card-body">
                      <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
                      <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
                      <h4 class="card-title">Sales Manager Agent List</h4>
                      <div v-if="display_div" class="row">
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>Select Manager</label>
                                  <model-select :options="admins"
                                                v-model="manager_user_id"
                                                placeholder="Select User">
                                  </model-select>
                              </div>
                          </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>Select Customer</label>
                                  <model-select :options="agents"
                                                v-model="customer_user_id"
                                                placeholder="Select User">
                                  </model-select>
                              </div>
                          </div>
                          <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

                      </div>
                  </div>
              </div>
          </div>
      </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Manager</th>
                    <th>Customer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(salesmanager,index) in manager_customer" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{arr_admins[salesmanager.manager_user_id]}}</td>
                    <td>{{arr_agents[salesmanager.customer_user_id]}}</td>
                    <td><button @click.prevent="deleteWarning(salesmanager)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i></button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
